import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Product from "../pages/product/page";
import Cases from "../pages/cases/page";
import FindDoctor from "../pages/find-doctor/page";
import ForDoctors from "../pages/for-doctors/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product",
    element: <Product />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/find-doctor",
    element: <FindDoctor />,
  },
  {
    path: "/for-doctors",
    element: <ForDoctors />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
